// Ensure namespace exists. ES module imports are hoisted, so this file runs
// before its parent (views/autocomplete.js) defines DoctorFinder.Views.Autocomplete.
DoctorFinder.Views.Autocomplete = DoctorFinder.Views.Autocomplete || {};

DoctorFinder.Views.Autocomplete.Spotlight = class Spotlight extends Sparkle.Spotlight {
  constructor() {
    super(...arguments);
    this.handleLeftPressed = this.handleLeftPressed.bind(this);
    this.handleRightPressed = this.handleRightPressed.bind(this);
    this.focusPrevious = this.focusPrevious.bind(this);
    this.focusNext = this.focusNext.bind(this);
    this.nextVisible = this.nextVisible.bind(this);
    this.previousVisible = this.previousVisible.bind(this);
    this._setKeyHandler(37, this.handleLeftPressed); // left
    this._setKeyHandler(39, this.handleRightPressed); // right
  }

  // EVENT HANDLERS

  handleLeftPressed() {
    const item = this.itemsList.items[this.focussedIndex];
    return item != null ? item.toggleClosed() : undefined;
  }

  handleRightPressed() {
    const item = this.itemsList.items[this.focussedIndex];
    return item != null ? item.toggleOpen() : undefined;
  }

  // API

  focusPrevious() {
    const index = this.previousVisible();
    if (this.options.unfocus && this.focussedIndex >= 0 && index >= this.focussedIndex) {
      return this.clearFocus();
    } else {
      if (index != null) {
        return this.setFocussed(index);
      }
    }
  }

  focusNext() {
    const index = this.nextVisible();
    if (index != null) {
      return this.setFocussed(index);
    }
  }

  // PRIVATE

  nextVisible() {
    let iterations = 0;
    let index = this.focussedIndex;
    const listLength = this.itemsList.items.length || 0;
    while (!(wrapped || index !== this.focussedIndex) && !(iterations > listLength)) {
      iterations++;
      index = (index + 1) % listLength;
      if (!wrapped) {
        var wrapped = index < this.focussedIndex;
      }
      if (this.isItemVisible(this.itemsList.items[index])) {
        return index;
      }
    }
  }

  previousVisible() {
    let iterations = 0;
    let index = this.focussedIndex;
    const listLength = this.itemsList.items.length || 0;
    while (!(wrapped || index !== this.focussedIndex) && !(iterations > listLength)) {
      iterations++;
      index = index <= 0 ? listLength - 1 : index - 1;
      if (!wrapped) {
        var wrapped = index > this.focussedIndex;
      }
      if (this.isItemVisible(this.itemsList.items[index])) {
        return index;
      }
    }
  }

  isItemVisible(item) {
    return item.el.is(":visible");
  }
};
